module.exports = __webpack_public_path__ + "img/img101.0d08be43.png";